const map = {
	"./0/Kambi/CrossActivity.resource.js": [
		32344,
		[
			2217
		]
	],
	"./0/Poker/CrossActivity.resource.js": [
		32805,
		[
			1228
		]
	],
	"./0/Spectate/CrossActivity.resource.js": [
		5477,
		[
			228
		]
	],
	"./1/Kambi/CrossActivity.resource.js": [
		58265,
		[
			4296
		]
	],
	"./1/Poker/CrossActivity.resource.js": [
		69712,
		[
			2573
		]
	],
	"./1/Spectate/CrossActivity.resource.js": [
		29674,
		[
			5109
		]
	],
	"./31/Kambi/CrossActivity.resource.js": [
		39664,
		[
			89
		]
	],
	"./31/Poker/CrossActivity.resource.js": [
		2349,
		[
			1126
		]
	],
	"./31/Spectate/CrossActivity.resource.js": [
		70429,
		[
			3918
		]
	],
	"./58/Spectate/CrossActivity.resource.js": [
		90340,
		[
			2241
		]
	],
	"./75/Kambi/CrossActivity.resource.js": [
		82088,
		[
			545
		]
	],
	"./75/Spectate/CrossActivity.resource.js": [
		35381,
		[
			606
		]
	],
	"./76/Kambi/CrossActivity.resource.js": [
		21971,
		[
			7070
		]
	],
	"./76/Spectate/CrossActivity.resource.js": [
		15208,
		[
			4337
		]
	],
	"./8/Poker/CrossActivity.resource.js": [
		95565,
		[
			436
		]
	],
	"./8/Spectate/CrossActivity.resource.js": [
		27389,
		[
			4156
		]
	],
	"./81/Kambi/CrossActivity.resource.js": [
		70609,
		[
			3240
		]
	],
	"./81/Spectate/CrossActivity.resource.js": [
		20770,
		[
			7683
		]
	],
	"./84/Kambi/CrossActivity.resource.js": [
		82508,
		[
			7773
		]
	],
	"./84/Spectate/CrossActivity.resource.js": [
		53849,
		[
			4694
		]
	],
	"./86/Spectate/CrossActivity.resource.js": [
		38375,
		[
			2408
		]
	],
	"./87/Spectate/CrossActivity.resource.js": [
		32956,
		[
			8585
		]
	],
	"./88/Spectate/CrossActivity.resource.js": [
		3397,
		[
			7858
		]
	],
	"./89/Spectate/CrossActivity.resource.js": [
		49130,
		[
			3387
		]
	],
	"./90/Spectate/CrossActivity.resource.js": [
		92544,
		[
			8618
		]
	],
	"./91/Spectate/CrossActivity.resource.js": [
		5643,
		[
			4364
		]
	],
	"./92/Spectate/CrossActivity.resource.js": [
		57714,
		[
			9283
		]
	],
	"./94/Spectate/CrossActivity.resource.js": [
		77324,
		[
			5001
		]
	],
	"./95/Spectate/CrossActivity.resource.js": [
		58711,
		[
			8168
		]
	],
	"./96/Poker/CrossActivity.resource.js": [
		67564,
		[
			999
		]
	],
	"./96/Spectate/CrossActivity.resource.js": [
		60638,
		[
			2527
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7413;
module.exports = webpackAsyncContext;